import { useState, type FormEvent } from "react";
import { BrandMark } from "./BrandMark";
import { SiteFilingFooter } from "./SiteFilingFooter";

export function LoginView({
  onLogin,
}: {
  onLogin: (password: string) => Promise<void>;
}) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await onLogin(password);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "没有完成登录");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-view">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="login-brand">
          <BrandMark />
          <p className="wordmark">TermClear</p>
        </div>
        <h1 id="login-title">个人术语学习库</h1>
        <p>把没听懂的术语和不会用的英语，慢慢变成真正会用的知识。</p>
        <form onSubmit={submit}>
          <label htmlFor="access-code">访问口令</label>
          <input
            id="access-code"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            autoFocus
          />
          {error ? <p className="form-error" role="alert">{error}</p> : null}
          <button className="primary-button" type="submit" disabled={busy}>
            {busy ? "正在进入…" : "进入词库"}
          </button>
        </form>
      </section>
      <SiteFilingFooter />
    </main>
  );
}
